// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./insa-css/style.css
// module id = 1886
// module chunks = 2